// extracted by mini-css-extract-plugin
export default {"default":"Tab_default__6IO2O"};